<template>
  <button
    v-if="backToggleFunction"
    class="back-button"
    @click.prevent.stop="backToggleFunction"
  >
    <svg class="icon"><use href="#arrow-left" /></svg>
    <span v-if="backToggleLabel">
      {{ backToggleLabel }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'BackButton',

  props: {
    backToggleFunction: {
      type: Function,
      default: null,
    },
    backToggleLabel: {
      type: String,
      default: '',
    },
  },
};
</script>
